package com.ijoin.i18n

/**
 * French strings implementation
 */
object FrenchStrings : Strings {
    override val appName = "iJoin"
    override val clickMe = "Cliquez ici !"
    override val greetingMessage = "Compose"
    override fun helloPlatform(platformName: String) = "Bonjour, $platformName !"
    override val language = "Langue"
    override val english = "Anglais"
    override val russian = "Russe"
    override val changeLanguage = "Changer la langue"
    override val ok = "OK"
    override val cancel = "Annuler"
    override val save = "Enregistrer"
    override val delete = "Supprimer"
    override val edit = "Modifier"
    override val close = "Fermer"
    override val retry = "Réessayer"
    override val share = "Partager"
    override val unknownErrorMessage = "Une erreur s'est produite. Veuillez réessayer."
    override val missingEventDateError = "La date de l'événement est manquante."
    override val slotSelectionRequired = "Sélectionnez au moins un créneau."
    override val userContextMissingError = "Impossible d'identifier l'utilisateur actuel."
    override val cancelSlotsSelectionRequired = "Sélectionnez au moins un créneau à annuler."
    override val cancelDaySelectionRequired = "Sélectionnez un jour à annuler."
    override val restoreSlotsSelectionRequired = "Sélectionnez au moins un créneau à restaurer."
    override val restoreDaySelectionRequired = "Sélectionnez un jour à restaurer."
    override val cancelSlotsFailed = "Impossible d'annuler les créneaux sélectionnés."
    override val cancelDayFailed = "Impossible d'annuler le jour sélectionné."
    override val restoreSlotsFailed = "Impossible de restaurer les créneaux sélectionnés."
    override val restoreDayFailed = "Impossible de restaurer le jour sélectionné."
    override val cancelEventFailed = "Impossible d'annuler l'événement."
    override val restoreEventFailed = "Impossible de restaurer l'événement."
    override val selectedDateUnavailableError = "La date sélectionnée n'est pas disponible."
    override val selectedDateInPastError = "La date sélectionnée est passée."
    override val notSelected = "Non sélectionné"
    override fun atTime(time: String) = "à $time"
    override val enableNotificationsTitle = "Restez informé"
    override val enableNotificationsBody = "Activez les notifications du navigateur pour recevoir des mises à jour sur les nouveaux événements et l'activité du chat."
    override val allowNotificationsAction = "Autoriser les notifications"
    override val notNowAction = "Pas maintenant"
    override val searchPlaceholder = "Rechercher événements, organisateurs, lieux..."
    override val myTickets = "Mes billets"
    override val tapToViewTicket = "Appuyez pour voir le billet"
    override val favoriteEvents = "Favoris"
    override val eventsYouSaved = "Événements que vous avez enregistrés"
    override val recommendedForYou = "Recommandés pour vous"
    override val curatedEvents = "Événements sélectionnés selon vos intérêts"
    override val recommendations = "Recommandations"
    override val upcomingEvents = "Événements à venir"
    override val searchResults = "Résultats de recherche"
    override val noResults = "Aucun résultat trouvé"
    override val noAvailableEvents = "Aucun événement disponible"
    override val createEvent = "Créer un événement"
    override val menu = "Menu"
    override val home = "Accueil"
    override val explore = "Explorer"
    override val tickets = "Billets"
    override val profile = "Profil"
    override val upcomingPaidTicketsTitle = "Prochains billets payés"
    override val otherTicketsTitle = "Autres billets"
    override val offlineTicketsNotice = "Affichage des billets enregistrés. Certaines informations peuvent être obsolètes."
    override val ticketsEmptyMessage = "Vous n'avez pas encore de billets."
    override val ticketDetailsTitle = "Détails du billet"
    override val ticketNumberLabel = "Numéro de billet"
    override val ticketStatusActive = "Actif"
    override val ticketStatusCancelled = "Annulé"
    override val ticketStatusRefunded = "Remboursé"
    override val ticketStatusUsed = "Utilisé"
    override val ticketHolderLabel = "Titulaire"
    override val cancelTicketAction = "Annuler le billet"
    override val ticketCancellationConfirmTitle = "Annuler le billet ?"
    override val ticketCancellationConfirmMessage = "Cela libérera votre place pour un autre participant."
    override val ticketCancellationSuccess = "Billet annulé"
    override val ticketCancellationFailure = "Impossible d'annuler le billet"
    override val ticketLoadError = "Impossible de charger le billet"
    override val refresh = "Actualiser"
    override val settings = "Paramètres"
    override val createEventTitle = "Créer un événement"
    override val eventTitle = "Titre de l'événement"
    override val eventTitlePlaceholder = "Entrez le nom de l'événement"
    override val eventDescription = "Description"
    override val eventDescriptionPlaceholder = "Décrivez votre événement..."
    override val aiGenerateDescription = "IA : générer une description"
    override val aiFormatDescription = "IA : structurer et finaliser la description"
    override val addMedia = "Ajouter photo/vidéo"
    override val mediaChooseFile = "Choisir un fichier"
    override val location = "Lieu"
    override val onlineEvent = "Événement en ligne"
    override val onlineLink = "Lien en ligne"
    override val onlineLinkPlaceholder = "https://exemple.com/reunion"
    override val onlineLinkNotice = "Le lien sera disponible après le paiement"
    override val placeName = "Nom du lieu"
    override val address = "Adresse"
    override val ticketPrice = "Prix du billet"
    override val ticketPricePlaceholder = "25,00"
    override val dateAndTime = "Date et heure"
    override val recurringEvent = "Événement récurrent"
    override val recurrenceType = "Type de récurrence"
    override val daysOfWeek = "Jours de la semaine"
    override val daysOfMonth = "Jours du mois"
    override val selectDaysOfWeek = "Sélectionner les jours de la semaine"
    override val selectDaysOfMonth = "Sélectionner les jours du mois"
    override val time = "Heure (HH:MM)"
    override val hiddenInfo = "Information cachée"
    override val hiddenInfoDescription = "Sera disponible pour les utilisateurs après l'achat du billet"
    override val hiddenInfoPlaceholder = "Information visible uniquement après le paiement..."
    override val enableGroupChatLabel = "Créer un chat de groupe"
    override val enableGroupChatDescription = "Tous ceux qui réservent ou achètent un billet rejoignent un chat partagé."
    override val groupChatLabel = "Chat de groupe"
    override val groupChatSubtitle = "Chat pour tous les participants"
    override val carpoolSettings = "Paramètres de covoiturage"
    override val enableCarpool = "Activer le covoiturage"
    override val contactInfoSettings = "Paramètres des coordonnées"
    override val requireContactInfo = "Collecter les coordonnées"
    override val requireContactInfoDescription = "Exiger des clients qu'ils fournissent leur téléphone et des informations supplémentaires lors de la réservation"
    override val freeCarpool = "Covoiturage gratuit"
    override val carpoolPaymentPerPerson = "Paiement par passager"
    override fun carpoolPaymentLabel(symbol: String) = "Paiement par personne ($symbol)"
    override val carpoolPaymentPlaceholder = "10,00"
    override val carpoolDescription = "Les utilisateurs peuvent indiquer qu'ils ont une voiture et préciser combien de passagers ils peuvent transporter"
    override val carpoolPaymentHint = "Définissez combien les passagers doivent payer pour le trajet"
    override val selectDate = "Sélectionner la date"
    override val back = "Retour"
    override val create = "Créer"
    override val currency = "Devise"
    override val selectCurrency = "Sélectionner la devise"
    override val category = "Catégorie"
    override val selectCategory = "Sélectionner la catégorie"
    override val tags = "Tags"
    override val addTag = "Ajouter un tag"
    override val maxCapacity = "Capacité maximale"
    override val maxCapacityPlaceholder = "50"
    override val duration = "Durée"
    override val durationMinutes = "Durée (minutes)"
    override fun formatDuration(minutes: Int): String {
        if (minutes <= 0) return ""
        val days = minutes / (24 * 60)
        val hours = (minutes % (24 * 60)) / 60
        val mins = minutes % 60

        return when {
            days >= 7 -> {
                val weeks = days / 7
                val remainingDays = days % 7
                if (remainingDays > 0) "$weeks semaine${if (weeks > 1) "s" else ""} $remainingDays jour${if (remainingDays > 1) "s" else ""}"
                else "$weeks semaine${if (weeks > 1) "s" else ""}"
            }
            days > 0 -> {
                if (hours > 0) "$days jour${if (days > 1) "s" else ""} $hours h"
                else "$days jour${if (days > 1) "s" else ""}"
            }
            hours > 0 -> {
                if (mins > 0) "$hours h $mins min"
                else "$hours h"
            }
            else -> "$mins min"
        }
    }
    override val locationCountry = "Pays"
    override val selectOnMap = "Sélectionner sur la carte"
    override val locationSearchPlaceholder = "Entrez l'adresse ou le nom du lieu"
    override val onlineLinkHidden = "Le lien sera visible uniquement après le paiement"
    override val timeZone = "Fuseau horaire"
    override fun timeZoneValue(timeZoneId: String) = "Fuseau horaire : $timeZoneId"
    override val selectTimeZone = "Sélectionner le fuseau horaire"
    override val localTimeZone = "Fuseau horaire local"
    override val mediaFilesAdded = "Fichiers ajoutés"
    override val free = "Gratuit"
    override val priceForFreeEvent = "0 - pour événement gratuit"
    override val additionalOptions = "Options supplémentaires"
    override val ageRestriction = "Limite d'âge"
    override val languageEvent = "Langue de l'événement"
    override val contactInfo = "Coordonnées"
    override val website = "Site web"
    override val phone = "Téléphone"
    override val email = "E-mail"
    override val comment = "Commentaire"
    override val phoneRequired = "Le téléphone est obligatoire"
    override val city = "Ville"
    override val search = "Rechercher"
    override val year = "Année"
    override val month = "Mois"
    override val day = "Jour"
    override fun weekdayShortName(index: Int) = listOf("Lun", "Mar", "Mer", "Jeu", "Ven", "Sam", "Dim")[index % 7]
    override fun weekdayName(index: Int) = listOf("Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche")[index % 7]
    override fun monthNameFull(month: Int) = listOf(
        "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
        "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"
    )[(month - 1).mod(12)]
    override fun monthNameGenitive(month: Int) = monthNameFull(month).lowercase()
    override val createEventWizard = "Créer un événement"
    override val step = "Étape"
    override val of = "sur"
    override val next = "Suivant"
    override val previous = "Précédent"
    override val saveDraft = "Enregistrer le brouillon"
    override val editEvent = "Modifier l'événement"
    override val step1BasicInfo = "Informations de base"
    override val step2Schedule = "Horaire"
    override val scheduleTypeLabel = "Type d'horaire"
    override val scheduleOneTimeDescription = "Événement unique à une date choisie"
    override val scheduleWeeklyDescription = "Se répète les jours sélectionnés"
    override val scheduleSlotDescription = "Calendrier de créneaux réservables"
    override val scheduleOneTimeSetup = "Configuration d'événement unique"
    override val schedulePreviewTitle = "Aperçu"
    override fun schedulePreviewDate(date: String) = "Date : $date"
    override fun schedulePreviewTime(start: String, end: String) = "Heure : $start - $end"
    override val step3Location = "Lieu"
    override val eventSetupTitle = "Configuration de l'événement"
    override val eventTypeLabel = "Type d'événement"
    override val oneTimeEvent = "Événement unique"
    override val eventSeries = "Série d'événements"
    override val weekly = "Hebdomadaire"
    override val monthly = "Mensuel"
    override val slotBooking = "Réservation de créneaux"
    override val slotLabel = "Créneau"
    override val slotsLabel = "Créneaux"
    override val selectDayOfWeek = "Sélectionner le jour de la semaine"
    override val selectDayOfMonth = "Sélectionner le jour du mois"
    override val availableTimeRange = "Plage horaire disponible"
    override val startTime = "Heure de début"
    override val endTime = "Heure de fin"
    override val endDateLabel = "Date de fin (optionnelle)"
    override val invalidEndDate = "La date de fin doit être égale ou postérieure à la date de début"
    override val invalidEndTime = "L'heure de fin doit être postérieure à l'heure de début"
    override val eventDateMustBeFuture = "La date de l'événement doit être dans le futur"
    override val eventTimeMustBeFuture = "L'heure de l'événement doit être postérieure à l'heure actuelle"
    override val slotSettings = "Paramètres des créneaux"
    override val minSlots = "Min. créneaux"
    override val minSlotsPlaceholder = "1"
    override val slotDuration = "Durée (min)"
    override val slotDurationPlaceholder = "30"
    override val perDayTimeConfiguration = "Heures disponibles pour chaque jour"
    override val driverCompensation = "Compensation du conducteur"
    override val fixedAmountPerPassenger = "Montant fixe par passager"
    override val coordinateRide = "Coordonner le trajet"
    override val participantsWithCar = "Participants avec voiture"
    override val needRide = "Besoin d'un transport"
    override val draft = "Brouillon"
    override val saved = "Enregistré"
    override val eventSaveErrorTitle = "Impossible d'enregistrer l'événement"
    override val eventSaveErrorMessage = "Une erreur s'est produite lors de l'enregistrement. Veuillez réessayer."
    override val deleteEventTitle = "Supprimer l'événement ?"
    override val deleteEventMessage = "Cette action ne peut pas être annulée. Voulez-vous continuer ?"
    override val eventDeletedMessage = "Événement supprimé"
    override val organizerLabel = "Organisateur"
    override val online = "En ligne"
    override val offline = "Sur place"
    override val eventDetailsTitle = "Détails de l'événement"
    override val addToFavorites = "Ajouter aux favoris"
    override val removeFromFavorites = "Retirer des favoris"
    override val ticketTierStandard = "Standard"
    override fun ticketsAvailable(count: Int) = "$count billets disponibles"
    override val viewTicket = "Voir le billet"
    override val bookingRequestFailed = "Impossible de réserver le billet"
    override val contactSendFailed = "Impossible d'envoyer les coordonnées"
    override val unexpectedReservation = "Réservation inattendue pour un événement gratuit"
    override val sampleReviewerName = "Marie Dupont"
    override val sampleReviewTimeAgo = "il y a 2 jours"
    override val selectVisitDate = "Sélectionner la date de visite"
    override fun availableDaysLabel(days: String) = "Jours disponibles : $days"
    override val previousMonth = "Mois précédent"
    override val nextMonth = "Mois suivant"
    override fun slotSelectionMessage(date: String, time: String?) =
        if (time.isNullOrBlank()) "Vous avez sélectionné : $date" else "Vous avez sélectionné : $date à $time"
    override fun eventImageContentDescription(title: String, index: Int) = "$title - Image $index"
    override val dateTbd = "À déterminer"
    override val recurringWeeklyDescription = "Cet événement a lieu chaque semaine aux jours sélectionnés."
    override val recurringMonthlyDescription = "Cet événement a lieu chaque mois aux jours sélectionnés."
    override val userCardTitle = "Profil de l'organisateur"
    override val followAction = "Suivre"
    override val followingAction = "Abonné"
    override val followersCountLabel = "Abonnés"
    override val followingCountLabel = "Abonnements"
    override val eventsCountLabel = "Événements"
    override val organizerEventsTitle = "Événements à venir"
    override val archiveSectionTitle = "Archives"
    override val aboutOrganizerTitle = "À propos de l'organisateur"
    override val userEventsEmpty = "Cet organisateur n'a pas encore d'événements à venir."
    override val userArchiveEmpty = "Aucun événement archivé."
    override val addShortcutTitle = "Ajouter un raccourci ?"
    override fun addShortcutMessage(displayName: String) =
        "Ajouter $displayName à votre écran d'accueil pour un accès rapide à leurs événements ?"
    override val addShortcutConfirm = "Ajouter le raccourci"
    override val addShortcutDismiss = "Pas maintenant"
    override val dateLabel = "Date"
    override val participants = "Participants"
    override val spotsLeft = "places restantes"
    override val ticketQuantityLabel = "Nombre de billets"
    override val increaseQuantity = "Augmenter la quantité"
    override val decreaseQuantity = "Diminuer la quantité"
    override val costLabel = "Coût de participation"
    override val serviceFee = "Frais de service"
    override val totalAmount = "Total"
    override fun serviceFeePercent(percent: Int) = "Frais de service ($percent%)"
    override val dressCode = "Code vestimentaire"
    override val dressCodePlaceholder = "Tenue de ville"
    override val description = "Description"
    override val reviews = "Avis"
    override val allReviews = "Tous les avis"
    override val contactOrganizer = "Contacter l'organisateur"
    override val slotBookingsTitle = "Réservations de créneaux"
    override val slotBookingsEmptyMessage = "Aucun créneau réservé pour le moment."
    override val showAllBookings = "Toutes"
    override val showToday = "Aujourd'hui"
    override val showThisMonth = "Ce mois"
    override val showSelectedDate = "Date sélectionnée"
    override val noBookingsForSelectedDate = "Aucune réservation pour cette date."
    override val noTicketsForSelectedDate = "Aucun billet pour cette date."
    override fun totalCount(count: Int) = "Total : $count"
    override val cancelEventAction = "Annuler l'événement"
    override val cancelEventDescription = "Arrêter la vente de billets et marquer l'événement comme annulé."
    override val organizerActionsTitle = "Outils de l'organisateur"
    override val eventAlreadyCancelledNotice = "L'événement est déjà annulé."
    override val eventCancelledTitle = "Événement annulé"
    override val eventCancelledSubtitle = "L'organisateur a annulé cet événement. La réservation n'est plus possible."
    override val cancellationReasonLabel = "Motif d'annulation"
    override val cancellationReasonPlaceholder = "Décrivez pourquoi vous annulez"
    override val cancellationReasonRequired = "Veuillez fournir un motif."
    override val cancelSelectedSlotsAction = "Annuler les créneaux sélectionnés"
    override val cancelSelectedSlotsDescription = "Les participants ne pourront plus réserver les créneaux sélectionnés."
    override val cancelSlotDayAction = "Annuler le jour sélectionné"
    override val cancelSlotDayDescription = "Tous les créneaux du jour sélectionné seront bloqués."
    override val selectedSlotsLabel = "Créneaux sélectionnés"
    override val selectedDayLabel = "Jour sélectionné"
    override val restoreEventAction = "Restaurer l'événement"
    override val restoreEventDescription = "Rouvrir l'événement après une annulation."
    override val restoreSelectedSlotsAction = "Restaurer les créneaux sélectionnés"
    override val restoreSelectedSlotsDescription = "Permettre aux participants de réserver à nouveau les créneaux sélectionnés."
    override val restoreSlotDayAction = "Restaurer le jour sélectionné"
    override val restoreSlotDayDescription = "Rouvrir tous les créneaux du jour sélectionné."
    override val bookingStatusPending = "En attente"
    override val bookingStatusConfirmed = "Confirmée"
    override val bookingStatusCancelled = "Annulée"
    override val bookingStatusCompleted = "Réservée"
    override val bookingStatusNoShow = "Absent"
    override val viewDetails = "Voir les détails"
    override val hideDetails = "Masquer les détails"
    override val openChat = "Ouvrir le chat"
    override val clientNotesLabel = "Commentaire du client"
    override val bookingDetailsTitle = "Détails de la réservation"
    override val slotBookedByLabel = "Réservé par"
    override val slotAvailableLabel = "Disponible"
    override val statusLabel = "Statut"
    override val connectTitle = "Paiements directs"
    override val connectStatusActive = "Actif"
    override val connectStatusPending = "En attente"
    override val connectStatusPlatform = "Plateforme"
    override val connectStatusUnderReview = "En cours de vérification"
    override val connectStatusSetupNeeded = "Configuration requise"
    override val connectEnableDirectAction = "Activer les paiements directs"
    override val connectContinueOnboarding = "Continuer la configuration"
    override val connectOpenDashboard = "Ouvrir le tableau de bord Stripe"
    override val connectSwitchToPlatform = "Passer aux paiements de la plateforme"
    override val connectPlatformFeeLabel = "Frais de la plateforme"
    override val connectDirectPaymentsEnabled = "Paiements directs activés"
    override val connectSwitchedToPlatform = "Basculé vers les paiements de la plateforme"
    override val connectOnboardingDescription = "Configurez votre compte Stripe pour recevoir les paiements directement"
    override val connectActiveDescription = "Les paiements vont directement sur votre compte Stripe"
    override val connectPlatformDescription = "Les paiements sont traités via la plateforme"
    override val connectUnderReviewDescription = "Votre compte est en cours de vérification par Stripe"
    override fun connectPlatformFeeValue(percent: Int) = "$percent%"

    override val billingTitle = "Facturation"
    override val currentBalanceLabel = "Solde actuel"
    override val openBillingAction = "Facturation et paiements"
    override val withdrawFundsAction = "Retirer des fonds"
    override val pendingPayoutsLabel = "Paiements en attente"
    override val withdrawnTotalLabel = "Retiré"
    override val billingFilterWeek = "7 jours"
    override val billingFilterMonth = "30 jours"
    override val billingFilterQuarter = "90 jours"
    override val grossSalesLabel = "Ventes brutes"
    override val feesLabel = "Frais"
    override val netRevenueLabel = "Revenu net"
    override val payoutRequestsTitle = "Demandes de retrait"
    override val payoutRequestsEmpty = "Aucune demande de retrait"
    override val payoutStatusPending = "En attente"
    override val payoutStatusProcessing = "En cours"
    override val payoutStatusPaid = "Payé"
    override val payoutStatusRejected = "Rejeté"
    override val requisitesTitle = "Détails de paiement"
    override val requisitesAccountLabel = "Numéro de compte"
    override val requisitesInnLabel = "INN"
    override val requisitesKppLabel = "KPP"
    override val requisitesBikLabel = "BIC"
    override val bankLabel = "Banque"
    override val soldTicketsTitle = "Billets vendus"
    override val soldTicketsEmpty = "Aucune vente de billets pendant cette période"
    override val withdrawConfirmTitle = "Retirer des fonds ?"
    override fun withdrawConfirmMessage(amount: String) = "Vous êtes sur le point de demander un paiement de $amount."
    override val billingWithdrawSuccess = "Demande de retrait envoyée"
    override val billingWithdrawFailed = "Impossible d'envoyer la demande de retrait"
    override val billingWithdrawUnavailable = "Aucun solde disponible pour le retrait"
    override val payoutMethodEtransfer = "eTransfer (Canada)"
    override val payoutMethodWise = "Virement Wise"
    override val payoutDetailsTitle = "Détails du paiement"
    override val payoutEmailLabel = "E-mail du destinataire"
    override val payoutWiseNameLabel = "Nom du titulaire du compte"
    override val payoutWiseAccountLabel = "Numéro de compte / IBAN"
    override val payoutWiseBankLabel = "Nom de la banque ou SWIFT"
    override val payoutWiseRoutingLabel = "Numéro de routage"
    override val payoutWiseAccountTypeLabel = "Type de compte"
    override val payoutAccountTypeChecking = "Courant"
    override val payoutAccountTypeSavings = "Épargne"
    override val payoutNoteLabel = "Note de retrait (optionnelle)"
    override fun soldTicketQuantity(quantity: Int, grossAmount: String) = "$quantity x $grossAmount"
    override fun soldTicketBuyerInfo(buyerName: String, soldAt: String) = "$buyerName - $soldAt"
    override fun soldTicketServiceFee(fee: String) = "- $fee"
    override fun shortMonthName(month: Int): String = when (month) {
        1 -> "Jan"; 2 -> "Fév"; 3 -> "Mar"; 4 -> "Avr"; 5 -> "Mai"; 6 -> "Juin"
        7 -> "Juil"; 8 -> "Août"; 9 -> "Sep"; 10 -> "Oct"; 11 -> "Nov"; 12 -> "Déc"
        else -> ""
    }
    override val accountDetails = "Détails du compte"
    override val interfaceLanguage = "Langue de l'interface"
    override val profileSavedMessage = "Profil mis à jour"
    override val profileLogoutDescription = "Se déconnecter de iJoin sur cet appareil."
    override val profileLoadError = "Impossible de charger le profil"
    override val logoutError = "Échec de la déconnexion. Veuillez réessayer."
    override val messagesTitle = "Messages"
    override val emptyChatList = "Aucune conversation"
    override val emptyMessages = "Aucun message. Commencez la conversation !"
    override val typeMessage = "Message..."
    override val send = "Envoyer"
    override val chatSearchPlaceholder = "Rechercher des utilisateurs par nom"
    override val chatSearchNoResults = "Aucun utilisateur trouvé"
    override val chatLoadError = "Impossible de charger les messages"
    override val chatSendError = "Impossible d'envoyer le message"
    override val chatOpenError = "Impossible d'ouvrir le chat"
    override val chatStartError = "Impossible de démarrer le chat"
    override val chatSearchError = "Impossible de rechercher des utilisateurs pour le moment"
    override val paymentTitle = "Paiement de la réservation"
    override val paymentSubtitle = "Complétez le paiement de votre réservation"
    override val paymentDescription = "Une fois le paiement réussi, votre réservation sera automatiquement mise à jour."
    override val paymentPreparing = "Préparation du paiement Stripe..."
    override val paymentFetchingTickets = "Récupération de vos billets..."
    override val paymentCompletedMessage = "Paiement confirmé. Si les billets n'apparaissent pas automatiquement, actualisez la liste."
    override val paymentStripePopupHint = "Stripe s'ouvre dans une fenêtre pop-up. Si rien n'est apparu ou si vous l'avez fermée, appuyez sur \"Relancer le paiement\"."
    override val paymentRetryButton = "Relancer le paiement"
    override val paymentRetryTicketsButton = "Récupérer les billets à nouveau"
    override val paymentStartFailed = "Échec du démarrage du paiement"
    override val paymentTicketContextMissing = "Impossible de déterminer la réservation pour émettre les billets"
    override val paymentTicketsNotFound = "Billets non trouvés"
    override val paymentTicketsFetchFailed = "Impossible de récupérer les billets"
    override val errorUserNotAuthenticated = "Veuillez vous connecter pour continuer."
    override val errorAccessDenied = "Vous n'avez pas la permission d'effectuer cette action."
    override val errorForbiddenFollowingList = "Vous ne pouvez voir que votre propre liste d'abonnements."
    override val errorDataUrlRequired = "Les données d'image (dataUrl) sont requises."
    override val errorMediaStoreFailed = "Échec du stockage du fichier. Veuillez réessayer."
    override val errorAmountMustBePositive = "Le montant doit être supérieur à zéro."
    override val errorAmountExceedsBalance = "Le montant demandé dépasse le solde disponible."
    override val errorPayoutEmailRequired = "L'e-mail est requis pour les paiements eTransfer."
    override val errorPayoutWiseInfoRequired = "Le nom complet, le numéro de routage et le numéro de compte sont requis pour les paiements Wise."
    override val errorPayoutAccountType = "Type de compte non pris en charge. Utilisez un compte courant ou épargne."
    override val errorUnsupportedPayoutMethod = "Méthode de paiement non prise en charge."
    override val errorEventNotCancelled = "L'événement n'est pas annulé."
    override val errorChatWithSelf = "Vous ne pouvez pas démarrer un chat avec vous-même."
    override val errorChatMessageEmpty = "Le message ne peut pas être vide."
    override val errorEventOrganizerRequired = "L'ID de l'événement et l'organisateur sont requis."
    override val errorEventUnavailable = "L'événement n'est plus disponible."
    override val errorEventFinished = "L'événement est déjà terminé."
    override val errorOrganizerNotProvider = "L'organisateur n'est pas un prestataire de services."
    override val errorServiceProviderInactive = "Le prestataire de services n'est pas actif."
    override val errorSlotsNotFound = "Certains créneaux n'ont pas été trouvés."
    override val errorSlotsMustSameEvent = "Tous les créneaux doivent appartenir au même événement."
    override val errorSlotsMustSameOrganizer = "Tous les créneaux doivent appartenir à l'organisateur de l'événement."
    override val errorSlotsUnavailable = "Un ou plusieurs créneaux ne sont pas disponibles."
    override val errorSlotsInPast = "Impossible de réserver des créneaux dans le passé."
    override val errorSlotsMustBeConsecutive = "Les créneaux doivent être consécutifs."
    override val errorEventIdRequired = "L'ID de l'événement est requis."
    override val errorQuantityAtLeastOne = "La quantité doit être d'au moins 1."
    override val errorPaidReservationRequired = "Cet événement nécessite une réservation payante."
    override val errorEventOrganizerInvalid = "L'organisateur de l'événement n'est pas valide."
    override val errorEventOrganizerMissing = "L'organisateur de l'événement n'est pas défini."
    override val errorOrganizerCannotAccept = "L'organisateur ne peut pas accepter les réservations."
    override val errorOccurrenceRequired = "La date de l'événement est requise."
    override val errorOccurrencePassed = "La date sélectionnée est déjà passée."
    override val errorTicketsNotEnough = "Pas assez de billets disponibles pour cet événement."
    override val errorBookingOtherUser = "La réservation appartient à un autre utilisateur."
    override val errorBookingNotAwaitingPayment = "La réservation n'est pas en attente de paiement."
    override val errorBookingCancelled = "La réservation est déjà annulée."
    override val errorBookingNotActive = "La réservation n'est plus active."
    override val errorBookingIssuedTickets = "La réservation a déjà des billets émis."
    override val errorEventRequiresPaymentFlow = "Cet événement nécessite un paiement. Complétez le paiement pour finaliser la réservation."
    override val errorReservationQuantityExceeded = "La quantité demandée dépasse la réservation."
    override val errorTicketAlreadyValidated = "Le billet a déjà été validé."
    override val errorTicketInactive = "Le billet n'est pas actif."
    override val errorTicketAlreadyCancelled = "Le billet est déjà annulé."
    override val errorTicketUsed = "Les billets utilisés ne peuvent pas être annulés."
    override val errorOccurrencesRequired = "Les dates sont requises."
    override val errorRequestRequired = "Les données de la requête sont requises."
    override val errorBookingEventMismatch = "La réservation ne correspond pas à l'événement fourni."
    override val errorBookingProcessed = "La réservation est déjà traitée."
    override val errorOverrideAmountAdminOnly = "Seuls les administrateurs peuvent modifier le montant."
    override val errorOverrideAmountPositive = "Le montant modifié doit être positif."
    override val errorUnableDetermineTicketPrice = "Impossible de déterminer le prix du billet."
    override val errorEmailAlreadyRegistered = "L'e-mail est déjà enregistré."
    override val errorInvalidCredentials = "E-mail ou mot de passe invalide."
    override val errorAccountInactive = "Le compte est inactif."
    override val errorInvalidRefreshToken = "Jeton d'actualisation invalide."
    override val errorAvatarDataUrlRequired = "Les données de l'avatar doivent être fournies en tant que data URL."
    override val errorAvatarMustBeImage = "L'avatar doit être une image."
    override val errorAvatarInvalidDataUrl = "Le data URL de l'avatar est invalide."
    override val errorStripeSignatureInvalid = "Signature Stripe invalide."
    override val errorMediaUnsupportedFormat = "Format d'image non pris en charge."
    override val errorReservationExpired = "La réservation a expiré. Veuillez en créer une nouvelle."
    override val login = "Connexion"
    override val register = "S'inscrire"
    override val continueWithGoogle = "Continuer avec Google"
    override val continueWithApple = "Continuer avec Apple"
    override val logout = "Déconnexion"
    override val password = "Mot de passe"
    override val username = "Nom d'utilisateur"
    override val firstName = "Prénom"
    override val lastName = "Nom"
    override val confirmPassword = "Confirmer le mot de passe"
    override val alreadyHaveAccount = "Vous avez déjà un compte ?"
    override val dontHaveAccount = "Vous n'avez pas de compte ?"
    override val loginHere = "Connectez-vous ici"
    override val registerHere = "Inscrivez-vous ici"
    override val welcomeBack = "Bon retour !"
    override val createAccount = "Créer un compte"
    override val loginError = "Échec de la connexion. Veuillez vérifier vos identifiants."
    override val registerError = "Échec de l'inscription. Veuillez réessayer."
    override val passwordsDontMatch = "Les mots de passe ne correspondent pas"
    override val fillAllFields = "Veuillez remplir tous les champs obligatoires"
    override val invalidEmail = "Veuillez entrer une adresse e-mail valide"
    override val forgotPassword = "Mot de passe oublié ?"
    override val passwordResetTitle = "Réinitialiser le mot de passe"
    override val passwordResetDescription = "Entrez votre adresse e-mail pour recevoir les instructions de réinitialisation."
    override val passwordResetSetNewPassword = "Définir un nouveau mot de passe"
    override val sendResetLink = "Envoyer le lien de réinitialisation"
    override fun passwordResetEmailSent(email: String) = "Si un compte existe pour $email, nous avons envoyé un lien de réinitialisation."
    override val passwordResetTokenLabel = "Jeton de réinitialisation"
    override val passwordResetTokenDescription = "Collez le code de votre e-mail ou ouvrez le lien sur cet appareil."
    override val newPassword = "Nouveau mot de passe"
    override val resetPasswordAction = "Mettre à jour le mot de passe"
    override val passwordResetSuccess = "Mot de passe mis à jour ! Vous pouvez vous connecter avec le nouveau mot de passe."
    override val backToLogin = "Retour à la connexion"
    override val profileDeletedMessage = "Compte supprimé"
    override val deleteAccountTitle = "Supprimer le compte"
    override val deleteAccountDescription = "Cela désactivera votre compte, anonymisera les données personnelles et supprimera vos événements des résultats de recherche."
    override val deleteAccountAction = "Supprimer le compte"
    override val deleteAccountConfirmMessage = "Êtes-vous sûr ? Veuillez retirer tout solde restant via une demande de paiement avant de supprimer votre compte."
    override val aiConsentSectionTitle = "Traitement des données d'IA"
    override val aiConsentEnabled = "Vous avez consenti à partager des données avec des services d'IA (OpenAI, Google) pour des fonctionnalités optionnelles comme la transcription et la génération de descriptions."
    override val aiConsentDisabled = "Le consentement au traitement des données d'IA n'est pas actif. Les fonctionnalités IA sont indisponibles."
    override val aiConsentWithdrawButton = "Retirer le consentement"
    override val aiConsentEnableButton = "Activer les fonctions IA"
    override val aiConsentWithdrawConfirmTitle = "Retirer le consentement IA ?"
    override val aiConsentWithdrawConfirmMessage = "Les fonctions IA (transcription, génération de descriptions, pages de destination) deviendront indisponibles. Vous pourrez les réactiver à tout moment."
    override val aiConsentWithdrawnSuccess = "Consentement au traitement des données d'IA retiré"
    override val aiConsentEnabledSuccess = "Consentement au traitement des données d'IA accordé"
    override val errorAccountDeleted = "Le compte a été supprimé."
    override val errorAccountBalanceNotZero = "Veuillez retirer le solde restant avant de supprimer votre compte."

    override val invalidPhone = "Veuillez entrer un numéro de téléphone valide"
    override val provideAnyContact = "Entrez téléphone ou e-mail"
    override val checkContacts = "Veuillez vérifier le format des contacts"
    override val contactSubmitting = "Enregistrement..."
    override val contactSubmitted = "Demande envoyée"
    override val book = "Réserver"
    override val bookFree = "Réserver gratuitement"
    override val bookingSuccess = "Réservé avec succès !"
    override val bookingFailed = "Échec de la réservation"
    override fun bookForPrice(price: String) = "Réserver pour $price"
    override val prev = "Précédent"
    override val showAll = "Tout afficher"
    override val collapse = "Réduire"
    override val missingTitle = "Entrez le titre de l'événement"
    override val missingDescription = "Entrez la description de l'événement"
    override val missingScheduleType = "Sélectionnez le type d'horaire"
    override val missingDate = "Sélectionnez la date de l'événement"
    override val missingTime = "Sélectionnez l'heure de l'événement"
    override val missingWeeklyDays = "Sélectionnez un ou plusieurs jours"
    override val missingWeeklyTime = "Sélectionnez l'heure pour l'événement hebdomadaire"
    override val missingSlotDays = "Sélectionnez les jours des créneaux"
    override val missingSlotStart = "Sélectionnez l'heure de début du créneau"
    override val missingSlotEnd = "Sélectionnez l'heure de fin du créneau"
    override val missingLocation = "Veuillez spécifier le lieu de l'événement"
    override val optional = "Optionnel"
    override val bookingsTitle = "Réservations"
    override val unconfirmedRequestsTitle = "Demandes non confirmées"
    override val detailsButton = "Détails"
    override val hideDetailsBooking = "Masquer"
    override val noBookings = "Aucune réservation"
    override val noUnconfirmedRequests = "Aucune demande non confirmée"
    override val ticketInfoLabel = "Billet"
    override val contactInfoLabel = "Coordonnées"
    override val paymentInfoLabel = "Paiement"
    override val loadingPayment = "Chargement..."
    override val clientLabel = "Client"
    override val paymentAmount = "Montant"
    override val paymentStatus = "Statut"
    override val paymentDate = "Date"
    override val appStoreBannerTitle = "Téléchargez l'app"
    override val appStoreBannerMessage = "Téléchargez notre application pour la meilleure expérience"
    override val downloadOnAppStore = "Télécharger sur l'App Store"
    override val getItOnGooglePlay = "Disponible sur Google Play"
    override val downloadAppLinks = "Téléchargez notre app"
    override val updateAvailable = "Mise à jour disponible"
    override val updateRequired = "Mise à jour requise"
    override val updateAvailableMessage = "Une nouvelle version de iJoin est disponible. Mettez à jour maintenant pour les dernières fonctionnalités et améliorations."
    override val updateRequiredMessage = "Veuillez mettre à jour iJoin pour continuer à utiliser l'application. Cette version n'est plus prise en charge."
    override val updateNow = "Mettre à jour"
    override val updateLater = "Plus tard"
    override val newVersion = "Nouvelle version"
    override val currentVersion = "Version actuelle"
    override val whatsNew = "Nouveautés"
    override val landingModeClassic = "Classique"
    override val landingModeAi = "Page d'atterrissage IA"
    override val landingModeTitle = "Type de page d'atterrissage"
    override val landingDescriptionLabel = "Description de la page"
    override val landingDescriptionPlaceholder = "Décrivez votre événement pour que l'IA génère une belle page d'atterrissage..."
    override val recordVoice = "Enregistrer la voix"
    override val stopRecording = "Arrêter l'enregistrement"
    override val transcribing = "Transcription..."
    override val recordingTooShort = "L'enregistrement est trop court (minimum 3 secondes)"
    override val recordingTooLong = "L'enregistrement est trop long (maximum 5 minutes)"
    override val microphoneAccessDenied = "Accès au microphone refusé"
    override fun recordingDuration(seconds: Int) = "${seconds}s"
    override val enableLandingPageLabel = "Utiliser une page d'atterrissage"
    override val enableLandingPageDescription = ""
    override val termsOfService = "Conditions d'utilisation"
    override val privacyPolicy = "Politique de confidentialité"
    override val refundPolicy = "Politique de remboursement et d'annulation"
    override val organizerTerms = "Conditions pour les organisateurs"
    override val aiDataConsent = "Consentement au traitement des données par l'IA"
    override val aiConsentTitle = "Les fonctions IA utilisent des services tiers"
    override val aiConsentDescription = "Certaines fonctionnalités de cette application utilisent des services d'intelligence artificielle fournis par OpenAI et Google. Lorsque vous utilisez ces fonctionnalités, certains contenus que vous fournissez sont envoyés à ces services pour traitement."
    override val aiConsentDataSent = "Données susceptibles d'être envoyées :"
    override val aiConsentDataSentAudio = "Enregistrements audio (pour la transcription)"
    override val aiConsentDataSentDescription = "Descriptions d'événements (pour l'amélioration du texte)"
    override val aiConsentDataSentLanding = "Détails de la page de destination (pour la génération de contenu)"
    override val aiConsentProviders = "Les données sont traitées par OpenAI (OpenAI, L.L.C.) et Google (Google LLC). Vos données personnelles (nom, e-mail) ne sont pas envoyées sauf si elles font partie du contenu soumis. Consultez le document complet pour plus de détails."
    override val aiConsentOptional = "Les fonctions IA sont facultatives. Vous pouvez utiliser l'application sans elles."
    override val aiConsentAccept = "J'accepte"
    override val aiConsentDecline = "Pas maintenant"
    override val iAgreeToThe = "J'accepte les conditions suivantes :"
    override val iAgreeToTerms = "J'accepte les Conditions d'utilisation, la Politique de confidentialité et la Politique de remboursement"
    override val iAgreeToOrganizerTerms = "J'accepte les Conditions pour les organisateurs"
    override val pleaseAcceptTerms = "Veuillez accepter les conditions pour continuer"
    override val pleaseAcceptOrganizerTerms = "Veuillez accepter les Conditions pour les organisateurs pour publier des événements"
    override val viewDocument = "Voir"
    override val legalDocumentLoading = "Chargement du document..."
    override val legalDocumentLoadError = "Échec du chargement du document"
    override val newUserGoogleNote = "Si vous êtes nouveau, veuillez accepter les conditions avant de vous connecter avec Google :"
    override val legalDocumentsUpdated = "Conditions mises à jour"
    override val legalDocumentsUpdatedDescription = "Nous avons mis à jour nos conditions. Veuillez lire et accepter les documents mis à jour pour continuer à utiliser l'application."
    override val iAcceptUpdatedTerms = "J'accepte les conditions mises à jour"
    override val continueButton = "Continuer"
    override val deleteEventFailed = "Impossible de supprimer l’événement."
    override val mediaDesktopLabel = "Pour ordinateur (large)"
    override val mediaMobileLabel = "Pour mobile (carré)"
    override val slotLoadFailed = "Impossible de charger les créneaux"
    override val slotBookingFailed = "Impossible de réserver les créneaux"
    override val ticketIssuanceFailed = "Impossible d’émettre les billets"
    override val unpublishedBookingNotice = "La réservation sera disponible une fois cet événement publié."
    override val paymentStripeOverlayTitle = "Paiement Stripe"
    override val paymentStripeOverlayDescription = "Saisissez les informations de votre carte pour finaliser la réservation."
    override val paymentStripeOverlayPayButton = "Payer maintenant"
    override val paymentStripeOverlayPayButtonLoading = "Traitement..."
    override val paymentStripeOverlayCancelButton = "Annuler"
    override val paymentStripeOverlayOpenError = "Impossible d’ouvrir le paiement Stripe."
    override val paymentStripeOverlayCancelMessage = "Paiement annulé"
    override val paymentStripeOverlayInitError = "Impossible d’initialiser Stripe."
    override val paymentStripeOverlayPaymentFailed = "Échec du paiement"
    override val paymentStripeOverlayUnexpectedStatusPrefix = "Statut inattendu : "
    override val paymentStripeOverlayProcessingFailed = "Échec du traitement du paiement"
    override val appStoreUnavailableMessage = "Désolé, l’application est en cours de publication sur la boutique et sera bientôt disponible."

}
